import { useState, memo, useMemo } from "react";
import useAuthUser from "../../../../common/hooks/authUser";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import defaultUserAvatar from "../../../../assets/svg/default-user-avatar.svg";
import { useUser } from "../../../../common/hooks/api/user";
import { getFormattedDate } from "../../../../helpers/date-time-helper";
import { toastError } from "../../../../helpers/toast-helper";
import { ScreenOverlay, Spinner } from "../../../../components/Common";
import { getResponseItemData } from "../../../../helpers/response-helper";
import { useCompanyLogo } from "../../../../common/hooks/api/company";
import { TNullable } from "../../../../common/types/common";

const UserProfile = () => {
    const [companyLogo, setCompanyLogo] = useState<TNullable<string>>(null);
    const { user } = useAuthUser();
    const { data: userResponse, isLoading } = useUser(user.id, {
        onError: () => {
            toastError("Cannot fetch user data");
        },
    });

    const { data } = getResponseItemData(userResponse);

    useCompanyLogo(data?.company?.id, {
        enabled: !!data?.company?.id,
        onSuccess: (imageBlob) => {
            const img = URL.createObjectURL(imageBlob);
            setCompanyLogo(img);
        },
        onError: () => {
            setCompanyLogo(null);
        },
    });

    const formattedCreatedDate = useMemo(() => data?.created ? getFormattedDate(data.created, "M/D/YYYY") : "", [data?.created]);
    const displayName = [data?.firstName, data?.lastName].join(' ');

    return (
        <>
            <Container fluid>
                <Row>
                    <Col lg="12">
                        <Card>
                            <CardBody>
                                <Container fluid>
                                    <Row>
                                        <Col xl="3" xs="6" className="d-flex">
                                            <div className="text-center">
                                                <img
                                                    src={defaultUserAvatar}
                                                    className="mb-3"
                                                />
                                                <div className="fs-6 fst-italic">User Since {formattedCreatedDate}</div>
                                            </div>
                                        </Col>
                                        <Col xl="9">
                                            <h3 className="mb-5">{displayName}</h3>
                                            <Container fluid>
                                                <Row>
                                                    <Col xl="5">
                                                        <p>
                                                            <span className="text-muted">Email:</span><br/>
                                                            <span>{data?.email || '-'}</span>
                                                        </p>
                                                        <p>
                                                            <span className="text-muted">Phone Number:</span><br/>
                                                            <span>{data?.phone || '-'}</span>
                                                        </p>
                                                    </Col>
                                                    <Col xl="5">
                                                        <p>
                                                            <span className="text-muted">Company:</span><br/>
                                                            <span>{data?.company?.name || '-'}</span>
                                                        </p>
                                                        <p>
                                                            <span className="text-muted">Company Logo:</span><br/>
                                                            {companyLogo ? (
                                                                <img src={companyLogo} alt="icons" height="100" width="100"/>
                                                            ) : '-'}
                                                        </p>
                                                    </Col>
                                                    <Col xl="2" className="text-end">
                                                        <p>
                                                            User id: {data?.id || '-'}
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </Col>
                                    </Row>
                                </Container>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </Container>
            {isLoading && (
                <>
                    <ScreenOverlay />
                    <Spinner />
                </>
            )}
        </>
    );
};

export default memo(UserProfile);
